<template>
  <van-row>
    <van-col span="24">
      <t-navbar v-if="showNav">
        <template v-slot:right>
          <slot name="navbar-right"></slot>
        </template>
      </t-navbar>
      <slot></slot>
    </van-col>
  </van-row>
</template>

<script>
import tNavbar from '@/components/navbar'

export default {
  name: 'layoutComponent',
  components: {
    tNavbar
  },
  props: {
    showNav: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
